import type {
  ConsentListener,
  ConsentProvider,
  ConsentSnapshot,
} from '@/Integrations/Consent/types';
import { loadExternalScript } from '@/Integrations/Shared/scriptLoader';
import {
  readConsentmanagerSnapshot,
  watchConsentmanagerConsent,
} from '@/Integrations/Consent/providers/nativeConsent';

interface ConsentmanagerProviderOptions {
  id: string;
  host?: string;
  cdn?: string;
}

export function createConsentmanagerProvider(
  options: ConsentmanagerProviderOptions,
): ConsentProvider {
  const listeners = new Set<ConsentListener>();

  const host = options.host || 'a.delivery.consentmanager.net';
  const cdn = options.cdn || 'cdn.consentmanager.net';

  let snapshot: ConsentSnapshot = {
    functional: true,
    analytics: false,
    marketing: false,
    source: 'default',
    updatedAt: Date.now(),
  };

  const publish = (next: ConsentSnapshot) => {
    snapshot = next;
    listeners.forEach((listener) => listener(snapshot));
  };

  return {
    name: 'consentmanager',
    async init() {
      await loadExternalScript({
        key: `cmp:consentmanager:${options.id}`,
        src: `https://${cdn}/delivery/autoblocking/${options.id}.js`,
        attributes: {
          'data-cmp-ab': '1',
          'data-cmp-host': host,
          'data-cmp-cdn': cdn,
          'data-cmp-codesrc': '0',
        },
      });

      watchConsentmanagerConsent(publish);
      publish(readConsentmanagerSnapshot());
    },

    getSnapshot() {
      return snapshot;
    },

    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
